export default __webpack_public_path__ + "static/media/Background_00111.0013d270.png";